<template>
  <v-card class="mb-5 pa-3 black lighten-2 h-100">
    <div class="text-left mb-4">
      <h2 class="text-h6 font-weight-bold">Mein Immobilien Portfolio</h2>
    </div>
    <v-row>
      <v-col cols="12" sm="4" class="mb-0 pb-0 mb-sm-2 pb-sm-1">
        <div class="d-flex flex-sm-column ga-2">
          <v-card flat class="pa-3 w-100 h-100 bg-grey-darken-35">
            <p class="text-disabled mb-0">Eigene</p>
            <p class="text-h5 font-weight-bold mb-0">
              {{ data.ownPropertiesCount }}
            </p>
          </v-card>
          <v-card flat class="pa-3 w-100 h-100 bg-grey-darken-35">
            <p class="text-disabled mb-0">Gespeichert</p>
            <p class="text-h5 font-weight-bold mb-0">
              {{ data.savedPropertiesCount }}
            </p>
          </v-card>
        </div>
      </v-col>
      <v-col cols="12" sm="8" class="pl-sm-0">
        <v-card
          flat
          class="d-flex flex-column h-100 align-center justify-center pa-2 bg-grey-darken-35"
        >
          <span class="position-absolute left-0 top-0 text-disabled px-3 py-1"
            >Marktwert</span
          >
          <BarChart
            v-if="!data.sumMarketValue <= 0"
            indexAxis="y"
            show-x
            label-name="EUR"
            :data="chartData"
          ></BarChart>
          <span
            class="font-weight-medium text-disabled my-5 d-flex align-center justify-center"
            v-else
            >Nicht genügend Daten vorhanden</span
          >
        </v-card>
      </v-col>
    </v-row>
    <v-card flat class="mt-3 bg-grey-darken-35">
      <p
        v-if="offers.length > 0"
        class="text-body-1 text-left text-disabled ma-2"
      >
        Meine Angebote
      </p>
      <p
        v-else
        class="text-body-1 text-center font-weight-medium text-disabled ma-2"
        @click="console.log(offers.length === 0)"
      >
        Keine Angebote vorhanden
      </p>
      <div class="overflow-y-hidden pa-1">
        <v-row class="flex-nowrap" style="width: max-content">
          <v-col
            v-for="(offer, index) in offers"
            :key="index"
            cols="auto"
            class="pa-0 pl-2 pr-2 py-2 ml-1 my-2"
          >
            <v-card
              @click="
                $router.push({
                  path: `/property/${offer.propertyId}`,
                  query: { tab: 'angebot' },
                })
              "
              v-tooltip:top="{
                text: 'Klicken, um Angebot anzusehen',
                openDelay: 2000,
              }"
              class="pa-2 bg-grey-darken-4 offer-tile"
            >
              <div class="d-flex ga-1 align-center mb-1">
                <span class="text-caption">{{ offer.label }}</span>
                <v-chip
                  :color="chipColor(offer.status)"
                  size="x-small"
                  class="font-weight-medium"
                >
                  <EnumDisplay
                    :enumObject="offerStatus"
                    :value="offer.status"
                  />
                </v-chip>
              </div>
              <p
                class="text-subtitle-2 d-flex justify-space-between align-center text-left mb-0"
                :class="{
                  'text-decoration-line-through text-grey':
                    offer.counterOffer || offer.status === 'DECLINED',
                  'font-weight-bold':
                    !offer.counterOffer || !offer.status === 'DECLINED',
                }"
              >
                <CurrencyDisplay :number="offer.purchasePrice" />
                <!-- <v-icon size="small" color="grey-darken-3">mdi-pencil</v-icon> -->
              </p>
              <div
                v-if="offer.counterOffer"
                class="text-subtitle-2 text-left font-weight-bold mb-0 d-flex justify-space-between align-center"
              >
                <CurrencyDisplay :number="offer.counterOffer" />
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-card>
</template>

<script>
import BarChart from "@/components/data/BarChart.vue";
import { useNotificationStore } from "@/stores/modules/notification.module";
import ApiService from "@/services/api.service";
import CurrencyDisplay from "@/components/helpers/CurrencyDisplay.vue";
import EnumDisplay from "@/components/helpers/EnumDisplay.vue";
import EOfferStatus from "@/components/enums/EOfferStatus.js";
// import CountUp from "@/components/helpers/CountUp.vue";
export default {
  setup() {
    const notificationStore = useNotificationStore();
    return {
      notificationStore,
    };
  },
  name: "UserInsights",
  components: {
    BarChart,
    EnumDisplay,
    CurrencyDisplay,
  },
  data() {
    return {
      data: {},
      chartData: [],
      offers: [],
      offerStatus: EOfferStatus,
    };
  },
  methods: {
    async getUserInsights() {
      this.loading = true;
      try {
        const response = await ApiService.get("dashboard/user");
        this.data = response.data;
        this.offers = this.data.estateOffers;
        console.log("avg", this.data.averageMarketValue);

        if (this.data.ownPropertiesCount > 1) {
          this.chartData = [
            {
              label: "Marktwert (gesamt)",
              average: this.data.averageMarketValue,
              value: this.data.sumMarketValue,
            },
          ];
        } else {
          this.chartData = [
            {
              label: "Marktwert (gesamt)",
              value: this.data.sumMarketValue,
            },
          ];
        }
      } catch (error) {
        this.notificationStore.pushError("Fehler beim Laden der Daten.");
      } finally {
        this.loading = false;
      }
    },
    chipColor(status) {
      switch (status) {
        case "PENDING":
          return "yellow";
        case "DECLINED":
          return "red";
        case "WITHDRAWED":
          return "red";
        case "ACCEPTED":
          return "green";
        case "COUNTER_OFFER":
          return "blue";
        default:
          return "grey";
      }
    },
  },
  async created() {
    await this.getUserInsights();
  },
};
</script>

<style scoped>
.bg-grey-darken-35 {
  background-color: #282727;
}
.offer-tile {
  transition: transform 0.2s ease-in-out;
}

.offer-tile:hover {
  transform: scale(1.05);
}
</style>
